import { useMemo } from 'react';
//
import { useGetCurrentUserQuery } from '../store/api/user.api';

export function useHasPermissions(requiredPermissions, every = false) {
  const {
    data: { permissions: userPermissions = [] },
  } = useGetCurrentUserQuery();
  return useMemo(() => {
    if (typeof requiredPermissions === 'string') {
      return userPermissions.includes(requiredPermissions);
    }
    const reqPermSet = new Set(requiredPermissions);
    const userPermSet = new Set(userPermissions);
    return (
      reqPermSet.intersection(userPermSet).size > 0 &&
      (!every || reqPermSet.isSubsetOf(userPermSet))
    );
  }, [requiredPermissions, userPermissions, every]);
}
